
import * as React from "react";
import { useSelector } from "react-redux";
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';

import closeIcon from '../assets/images/cross-close.svg';
const { useState, useEffect } = React;

export const ConfirmDeleteModel = ({ showModel, closeModel, displayMessage, confirmAction }) => {
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);

    const confirmOrCancelDeleteEvents = (e) => {
 
    }

    return (
        <>
            <Modal show={showModel} onHide={closeModel} className="modalStyle p-0">
                <Modal.Body className="p-0">
                    <div className="modal-container">
                        <div className="d-flex justify-content-between mb-4">
                            <p className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["eventDeleteWindowModalTitle"] : "Confirm Delete"} </p>
                            <img src={closeIcon} onClick={closeModel} className="cursor-pointer" />
                        </div>
                        <div className="d-flex justify-content-between mb-4">
                            {displayMessage}
                        </div>
                        <div className="d-flex">
                            <button className="filter-btn site-btn-padd border-dark color-dark w-100 me-3" id="cancel" onClick={closeModel}>{reduxLanguageTranslations ? reduxLanguageTranslations["eventDeleteWindowModalCancelBtn"] : "Cancel"}</button>
                            <button className="site-btn site-btn-padd w-100" id="confirm" onClick={confirmAction}>{reduxLanguageTranslations ? reduxLanguageTranslations["eventDeleteWindowModalConfirmBtn"] : "Confirm"}</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}







